import { AxiosResponse } from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";

// import type { User } from '../../../../../shared/types';
import {
  axiosInstance,
  // getJWTHeader,
  axiosInstance2,
} from "../../../../axiosInstance";
import { ErrorHandler } from "../../../../core/helpers";
import { ErrorToast, SuccessToast } from "../../../componets/toast";
import { queryKeys } from "../../../react-query/constants";

async function getMdaWithService(): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/organization/api/organizations/organizations-with-active-services-and-visibility`
  );
  return data;
}

async function getAllMda(): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/organization/api/organizations`
  );
  return data;
}

async function getAllMdawithFilter(filter: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/organization/api/organizations/filter?${filter}`
  );
  return data;
}

export async function searchMDa(search: string): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/organization/api/organizations/find-by-sector-code/${search}`
  );
  return data;
}

export async function createInvoice(
  expiry_date: string,
  values: any
): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.post(
    `/services/collection/api/invoices/create`,
    values
  );
  return data;
}
export async function requestReviewed(id: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.post(
    `/services/organization/api/organizations/review-awaiting-requests/${id.id}?status=${id.type}`,
    { revCode: id?.revenueCode, reason: id?.reason }
  );
  return data;
}

export async function getInvoice(invoice: string): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/collection/api/invoices/number/${invoice}`
  );
  return data;
}

export async function getAllInvoiceInfo(invoice: string): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/collection/api/invoices/number/${invoice}/full`
  );
  return data;
}

async function getPayRef(payRef: string): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    // `/services/collection/api/payments-by-grr/${payRef}`
    `services/collection/api/invoice-by-payment-reference-number/${payRef}`
  );
  return data;
}

async function getPaymentList(): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/collection/api/payment-gateways`
  );
  return data;
}

export async function getPaymentDetails(
  paymentId: string
): Promise<any | null> {
  const token: string | null = localStorage.getItem("token");

  axiosInstance2.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/collection/api/payment-by-receipt/${paymentId}`
  );
  return data;
}

export async function sendEmailRecieptToUserInvoiceId(
  invoice: string
): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.post(
    `/services/collection/api/payments/${invoice}/send-payment-notification`
  );
  return data;
}

export async function sendEmailRecieptToUserPaymentId(
  paymentId: string
): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.post(
    `/services/collection/api/payments/${paymentId}/send-payment-notification-by-receipt`
  );
  return data;
}

async function getServiceType(id: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.get(
    `/services/collection/api/organizations/${id}/services`
  );
  return data;
}

async function getAwaitingRequest(): Promise<any | null> {
  const token: string | null = localStorage.getItem("token");
  axiosInstance2.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  const orgId: string | null = localStorage.getItem("orgId");

  if (orgId !== "null") {
    const { data }: AxiosResponse<any> = await axiosInstance2.get(
        `/services/organization/api/organizations/requests/awaiting-requests`
    );
    return data;
  } else {
    return []
  }

}

async function confirmPayment(values: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance2.post(
    `/services/collection/api/pay`,
    values
  );
  return data;
}
async function submitPaymentRevenue(values: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance.post(
    `/services/collection/api/payment/revenue-payment-request `,
    values
  );
  return data;
}

async function getInvoiceRequest(values: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance.post(
    `/services/collection/api/payment/invoice-request`,
    values
  );

  return data;
}

async function requestSubscribtion(values: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance.post(
    `/services/collection/api/payment/subscribtion`,
    values
  );

  return data;
}

async function getRevenuePaymentRequesRefid(values: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance.post(
    `/services/collection/api/payment/revenue-payment-request-by-refid`,

    values
  );

  return data;
}

async function getUpdateInvoice(values: any): Promise<any | null> {
  const { data }: AxiosResponse<any> = await axiosInstance.get(
    `/services/collection/api/invoices/status/update/${values}`,
  );

  return data;
}

// export function useGetAllMda(): any {
//   const queryClient = useQueryClient();

//   const {
//     data: mdaList,
//     isError,
//     isLoading,
//     error,
//   } = useQuery(queryKeys.mdaList, () => getAllMda());

//   return { mdaList, isLoading, error };
// }

export function useGetAllMda(): any {
  return useMutation(() => getAllMda(), {
    onSuccess: (res) => {
      // console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}
export function useGetAllMdaFilter(): any {
  return useMutation((filter) => getAllMdawithFilter(filter), {
    onSuccess: (res) => {
      // console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function usePaymentMda(): any {
  return useMutation(() => getMdaWithService(), {
    onSuccess: (res) => {
      // console.log(res);
    },
    onError: (err: any) => {
      let message = "";

      if (err.response) {
        const errMessage = err.response.data;
        message = errMessage.message
          ? errMessage.message
          : "Something went wrong.";
      } else {
        message = err.message;
      }
      ErrorToast(message);
      ErrorHandler(err);
    },
  });
}

export function useOrgnizationService(id: any): any {
  const queryClient = useQueryClient();

  const {
    data: serviceTypeList,
    isError,
    isLoading,
    error,
  } = useQuery(queryKeys.serviceTypeList, () => getServiceType(id));

  return { serviceTypeList, isLoading };
}

export function useSubmitPaymentRev(): any {
  return useMutation((value) => submitPaymentRevenue(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useRevenuePaymentRequesRefid(): any {
  return useMutation((value) => getRevenuePaymentRequesRefid(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useUpdateInvoice(): any {
  return useMutation((value) => getUpdateInvoice(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useInvoiceRequest(): any {
  return useMutation((value) => getInvoiceRequest(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useRequestSubscribtion(): any {
  return useMutation((value) => requestSubscribtion(value), {
    onSuccess: (res) => {
      SuccessToast("Your request was successful");
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useConfirmPayment(): any {
  return useMutation((value) => confirmPayment(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useGetAwaitingRequest(): any {
  return useMutation(() => getAwaitingRequest(), {
    onSuccess: (res) => {},
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useRequestReviewed(): any {
  return useMutation((id) => requestReviewed(id), {
    onSuccess: (res) => {},
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useRecieptByInvoice(): any {
  return useMutation(
    (invoiceId: string) => sendEmailRecieptToUserInvoiceId(invoiceId),
    {
      onSuccess: (res) => {},
      onError: (err: any) => {
       ErrorHandler(err);
      },
    }
  );
}

export function useRecieptByPayment(): any {
  return useMutation(
    (paymentId: string) => sendEmailRecieptToUserPaymentId(paymentId),
    {
      onSuccess: (res) => {},
      onError: (err: any) => {
       ErrorHandler(err);
      },
    }
  );
}

export function useGetMdabySector(): any {
  return useMutation((value: string) => searchMDa(value), {
    onSuccess: (res) => {},
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useGetInvoice(): any {
  return useMutation((value: string) => getInvoice(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useGetPayRef(): any {
  return useMutation((value: string) => getPayRef(value), {
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function usePaymentList(): any {
  return useMutation(() => getPaymentList(), {
    onSuccess: (res) => {},
    onError: (err: any) => {
     ErrorHandler(err);
    },
  });
}

export function useDownloadInflowReport(): any {
  async function inFlow(filter): Promise<any | null> {
    const data: AxiosResponse<{ user: any }> =
      await axiosInstance2.get(
        `/services/collection/api/inflow-controller?${filter}`
      );
    return data;
  }
  return useMutation((filter) => inFlow(filter), {
    onSuccess: (res) => {},
    onError: (err: any) => {
      ErrorHandler(err);
    },
  });
}

export function useDownloadOutflowReport(): any {
  async function outFlow(filter): Promise<any | null> {
    const data: AxiosResponse<{ user: any }> =
      await axiosInstance2.get(
        `/services/organization/api/organizations/outflow-controller?${filter}`
      );
    return data;
  }
  return useMutation((filter) => outFlow(filter), {
    onSuccess: (res) => {},
    onError: (err: any) => {
      ErrorHandler(err);
    },
  });
}